import { useCallback } from 'react';
import { router } from '@inertiajs/react'
import { vacancies } from "@/api";

export default function VacancyFile({ vacancy, vacancyFile }) {
  const remove = useCallback(() => {
    router.delete(vacancies.destroy.path({ id: vacancy.id }))
  });

  return (
    <div className="mt-4 p-4 bg-gray-50 rounded-lg">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center">
          <svg
            className="h-6 w-6 text-gray-400 mr-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
          <span className="text-sm font-medium text-gray-900">
            {vacancyFile.filename}
          </span>
        </div>
        <button
          onClick={remove}
          className="text-sm text-red-600 hover:text-red-800"
        >
          清除
        </button>
      </div>
    </div>
  );
}
